import { getResponse } from '@satellite/services/serviceUtilities';

/**
 * options: { fields: string[], joins: string[], includeMetaData: boolean }
 */

/**
 * @typedef {Object} AuthServiceOptions
 * @property {string[]} fields
 * @property {string[]} joins
 * @property {boolean} includeMetaData
 */
// TODO: Add return types here when time permits
export default {
  /**
   * @param {AuthServiceOptions} [options]
   * @param {import('axios').AxiosRequestConfig} [requestConfig]
   * @returns {Promise<Object>}
   */
  async getMe(options = {}, requestConfig = {}) {
    const response = await axios.get(`auth/me`, { ...requestConfig });
    return getResponse(response, options);
  },

  /**
   * @param {{ email: string, password: string }} params
   * @param {AuthServiceOptions} [options]
   * @returns {Promise<Object>}
   */
  async login(params, options = {}) {
    const response = await axios.post(`auth/login`, params);
    return getResponse(response, options);
  },

  /**
   * Exchanges the single-use cross-portal handoff code (held in an HttpOnly cookie) for the real
   * access token. `withCredentials` sends that cookie.
   * @returns {Promise<string|undefined>}
   */
  async exchangeHandoffCode() {
    const response = await axios.post(
      'auth/exchange',
      {},
      { withCredentials: true, skipUnauthorizedRedirect: true, suppressNotification: true }
    );
    return response?.data?.access_token;
  }
};
